// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attendant-card_attendee-card-container__WQOKr {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.attendant-card_attendee-card__K0n0k {
  background-color: var(--white-text-color);
  padding: 24px;
  border-radius: 6px;
}

.attendant-card_attendee-header__quRUv {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
}

.attendant-card_participants-header__ciFO3 {
  display: flex;
  align-items: center;
  gap: 4px;
}

.attendant-card_progress-bar-container__bZaZQ {
  width: 100%;
  background-color: var(--primary-background-color);
  height: 10px;
  border-radius: 10px;
}

.attendant-card_progress-bar__mAD94 {
  background-color: var(--highlight-blue-color);
  height: 10px;
  border-radius: 10px;
}

.attendant-card_participant-list__cDtd5 {
  list-style: none;
  padding: 0;
  margin: 0;
}

.attendant-card_participant__pOLlz {
  display: flex;
  gap: 12px;
}

.attendant-card_icon__TZDml {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

li:nth-child(4n + 1) .attendant-card_icon__TZDml {
  background-color: #f0c7c7;
}

li:nth-child(4n + 2) .attendant-card_icon__TZDml {
  background-color: #cfc7f0;
}

li:nth-child(4n + 3) .attendant-card_icon__TZDml {
  background-color: #c7f0e0;
}

li:nth-child(4n + 4) .attendant-card_icon__TZDml {
  background-color: #f7ffc4;
}

.attendant-card_participant-name__y48\\+c {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 12px;
  max-width: 200px;
  min-width: 50px;

  & p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.attendant-card_participant-grid__nZ6fP {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.attendant-card_informations__tsyqu {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 24px;
}

.attendant-card_empty-participants__7SsC2 {
  width: 100%;
}

.attendant-card_disclaimer-wrapper__\\+0iWD {
  padding: 4px 6px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  width: fit-content;
  border: 1px solid var(--primary-border-color);
}

.attendant-card_refund__Zo\\+a8 {
  text-decoration: underline;
  color: var(--secondary-background-color);
}

.attendant-card_substitutes__WnHe9 {
  display: flex;
  align-items: center;
  gap: 8px;
}

.attendant-card_subtitutes-wrapper__34OT6 {
  display: flex;
  align-items: center;
  background-color: var(--primary-background-color);
  color: var(--secondary-accent-text-color);
  padding: 4px 6px;
  border-radius: 4px;
}

@media (max-width: 768px) {
  .attendant-card_participant-grid__nZ6fP {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/attendant-card.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yCAAyC;EACzC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,iDAAiD;EACjD,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;EAC7C,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;;EAEf;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iDAAiD;EACjD,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".attendee-card-container {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.attendee-card {\n  background-color: var(--white-text-color);\n  padding: 24px;\n  border-radius: 6px;\n}\n\n.attendee-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 4px;\n}\n\n.participants-header {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.progress-bar-container {\n  width: 100%;\n  background-color: var(--primary-background-color);\n  height: 10px;\n  border-radius: 10px;\n}\n\n.progress-bar {\n  background-color: var(--highlight-blue-color);\n  height: 10px;\n  border-radius: 10px;\n}\n\n.participant-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.participant {\n  display: flex;\n  gap: 12px;\n}\n\n.icon {\n  width: 25px;\n  height: 25px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\nli:nth-child(4n + 1) .icon {\n  background-color: #f0c7c7;\n}\n\nli:nth-child(4n + 2) .icon {\n  background-color: #cfc7f0;\n}\n\nli:nth-child(4n + 3) .icon {\n  background-color: #c7f0e0;\n}\n\nli:nth-child(4n + 4) .icon {\n  background-color: #f7ffc4;\n}\n\n.participant-name {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  align-items: center;\n  gap: 12px;\n  max-width: 200px;\n  min-width: 50px;\n\n  & p {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.participant-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.informations {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0 24px;\n}\n\n.empty-participants {\n  width: 100%;\n}\n\n.disclaimer-wrapper {\n  padding: 4px 6px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  width: fit-content;\n  border: 1px solid var(--primary-border-color);\n}\n\n.refund {\n  text-decoration: underline;\n  color: var(--secondary-background-color);\n}\n\n.substitutes {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.subtitutes-wrapper {\n  display: flex;\n  align-items: center;\n  background-color: var(--primary-background-color);\n  color: var(--secondary-accent-text-color);\n  padding: 4px 6px;\n  border-radius: 4px;\n}\n\n@media (max-width: 768px) {\n  .participant-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"attendee-card-container": `attendant-card_attendee-card-container__WQOKr`,
	"attendee-card": `attendant-card_attendee-card__K0n0k`,
	"attendee-header": `attendant-card_attendee-header__quRUv`,
	"participants-header": `attendant-card_participants-header__ciFO3`,
	"progress-bar-container": `attendant-card_progress-bar-container__bZaZQ`,
	"progress-bar": `attendant-card_progress-bar__mAD94`,
	"participant-list": `attendant-card_participant-list__cDtd5`,
	"participant": `attendant-card_participant__pOLlz`,
	"icon": `attendant-card_icon__TZDml`,
	"participant-name": `attendant-card_participant-name__y48+c`,
	"participant-grid": `attendant-card_participant-grid__nZ6fP`,
	"informations": `attendant-card_informations__tsyqu`,
	"empty-participants": `attendant-card_empty-participants__7SsC2`,
	"disclaimer-wrapper": `attendant-card_disclaimer-wrapper__+0iWD`,
	"refund": `attendant-card_refund__Zo+a8`,
	"substitutes": `attendant-card_substitutes__WnHe9`,
	"subtitutes-wrapper": `attendant-card_subtitutes-wrapper__34OT6`
};
export default ___CSS_LOADER_EXPORT___;
